// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1276":"ff6a6905","1722":"4244c2d1","1942":"01d92c2f","2025":"633cca7d","3351":"356e0c5f","3630":"ff6a6905","8685":"6edd45e9","9972":"ff6a6905"}[chunkId] + ".chunk.css";
};